import { getAll, get } from "@/utilities/querySelector";
import { freezeInViewObserver } from "@/global/scrollIntoView";

// Helper functions that need to be accessible to multiple functions
const formatValue = (value) => value.trim().toLowerCase().replace(/\s+/g, '-').replace(/"/g, '');

const mapServiceValue = (value) => {
    const serviceMap = {
        'Optical': 'eye-test',
        'Audiology': 'hearing-health-check',
    };
    return serviceMap[value] || value;
};

const mapBranchValue = (value) => {
    const branchMap = {
        '329': 'norwich',
        '330': 'swaffham',
        '331': 'diss',
    };
    return branchMap[value] || value;
};

const getSelectedService = () => {
    const serviceInputs = getAll('input[name="service"]');
    const selectedRadio = Array.from(serviceInputs).find(radio => radio.checked);
    return selectedRadio ? selectedRadio.value : '';
};

const updateSelectedServiceFields = (selectedServiceFields) => {
    if (!selectedServiceFields.length) {
        return;
    }

    selectedServiceFields.forEach(selectedServiceField => {
        if (!selectedServiceField) {
            return;
        }

        const selectedService = getSelectedService();
        if (selectedService) {
            selectedServiceField.textContent = `${selectedService}`;
        } else {
            selectedServiceField.textContent = '';
        }
    });
};

const updateSubmitButtonID = () => {
    const branchField = get('select[name="appointment-branch"]');
    const submitButton = get('button[type="submit"]');
    if (!branchField || !submitButton) return;

    const branch = formatValue(mapBranchValue(branchField.value));
    const service = formatValue(mapServiceValue(getSelectedService()));
    submitButton.id = `appointment-submit-${branch}-${service}`;
};

document.addEventListener('DOMContentLoaded', () => {
    const multiStepForms = getAll( 'form.cf7mls-no-scroll' );
    if (multiStepForms) {
        multiStepForms.forEach(stepForm => {
            const steps = getAll('.fieldset-cf7mls', stepForm);
            if (steps) {
                steps.forEach((step, index) => {
                    const fields = getAll('input, select, textarea', step);
                    const prevButton = get('.cf7mls_back', step);
                    const nextButton = get('.cf7mls_next', step);

                    fields.forEach(field => {
                        field.addEventListener('change', () => {

                            freezeInViewObserver(stepForm.closest('[data-in-view-target]'));

                            if (requiredFieldsFilled(fields)) {
                                if (nextButton) {
                                    // if (index === 0) {
                                    //     setTimeout(() => {
                                    //         nextButton.click();
                                    //     }, 500);
                                    // } else {
                                    nextButton.classList.add('cf7mls_next--active');
                                    // }
                                }
                            } else {
                                if (nextButton) {
                                    nextButton.classList.remove('cf7mls_next--active');
                                }
                            }
                        });
                    });
                });
            }

            const branchField = get('select[name="appointment-branch"]', stepForm);
            const serviceInputs = getAll('input[name="service"]', stepForm);
            const selectedServiceFields = getAll('div[data-selected-service]', stepForm);
            const submitButton = get('button[type="submit"]', stepForm);

            if (branchField && serviceInputs.length && submitButton) {
                branchField.addEventListener('input', updateSubmitButtonID);
                serviceInputs.forEach(radio => {
                    radio.addEventListener('change', updateSubmitButtonID);
                    radio.addEventListener('change', () => updateSelectedServiceFields(selectedServiceFields));
                });
            }
        });
    }

    addPreFillEventListener();
});

/**
 * Checks if all fields in the given NodeList are filled.
 *
 * @param {NodeListOf<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>} fields - The fields to check.
 * @returns {boolean} - Returns true if all fields are filled, otherwise false.
 */
function requiredFieldsFilled(fields) {
    const radioGroups = new Set();

    for (let field of fields) {
        const isRequired = field.classList.contains('wpcf7-validates-as-required') ||
        (field.closest('.wpcf7-form-control') && field.closest('.wpcf7-form-control').classList.contains('wpcf7-validates-as-required'));

        if (!isRequired) {
            continue;
        }

        if (field.type === 'checkbox') {
            if (!field.checked) {
                return false;
            }
        } else if (field.type === 'radio') {
            if (!radioGroups.has(field.name)) {
                const radioGroup = getAll(`input[type="radio"][name="${field.name}"]`, field.closest('.wpcf7-radio'));
                const isChecked = Array.from(radioGroup).some(radio => radio.checked);
                if (!isChecked) {
                    return false;
                }
                radioGroups.add(field.name);
            }
        } else if (field.value.trim() === '') {
            return false;
        }
    }

    return true;
}

/**
 * Add an event listener to pre fill a form field
 */
function addPreFillEventListener() {
    const preFillFormButtons = getAll('.button[data-form-fill-name][data-form-fill-value]');
    if (preFillFormButtons) {
        preFillFormButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                const formFillName = button.getAttribute('data-form-fill-name');
                const formFillValue = button.getAttribute('data-form-fill-value');
                const formField = get(`[name="${formFillName}"]`);
                if (formField) {
                    formField.value = formFillValue;
                    if (formFillName === 'appointment-branch') {
                        updateSubmitButtonID();
                    }
                }
            });
        });
    }
}
